import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { withTranslation } from 'react-i18next';

class TermThemeLink extends Component {
	constructor(props) {
		super(props);
		this.showInfoDialog = this.showInfoDialog.bind(this);
		this.hideInfoDialog = this.hideInfoDialog.bind(this);
		this.state = {
			showInfoDialog: false
		};
	}

	showInfoDialog() {
		this.setState({
			showInfoDialog: true
		});
	}

	hideInfoDialog() {
		this.setState({
			showInfoDialog: false
		});
	}

	renderInfoDialog() {
		const { term } = this.props;

		const header = term && term.name;
		const body = term && <div dangerouslySetInnerHTML={{ __html: term.themeDescription }} />;

		return <Dialog show={this.state.showInfoDialog} onHide={this.hideInfoDialog} header={header} body={body} />;
	}

	render() {
		const { term } = this.props;
		const infoDialog = this.renderInfoDialog();

		return term ? <span>
			<a style={{ cursor: 'pointer' }} onClick={this.showInfoDialog}>{term.name}</a>
			{infoDialog}
		</span> : null;
	}
}

TermThemeLink.propTypes = {
	term: PropTypes.shape({
		name: PropTypes.string,
		themeDescription: PropTypes.string
	})
};

export default withTranslation()(TermThemeLink);